import React from "react";

//css
import "./di-styles.css";

const TypesOfDia = () => {
  return (
    <section id="types-of-dia" className="types-wrapper">
      <div className="main-padding">
        <div className="main-margin">
          <div className="types-inner">
            <h1 className="sub-header">
              Types of Digital Infrastructure Assets
            </h1>
            <div>
              Connected devices often rely on sophisticated networks made up of
              various digital infrastructure assets. Each asset serves a unique
              purpose and they all work together to provide seamless
              connectivity as well as timely data and information.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TypesOfDia;
